import React from 'react'
import Onboarding from 'src/app/Onboarding/Onboarding'

/**
 * Flat-route adapter for the /onboarding/card entry point.
 *
 * The flat route registry binds a prop-less `ComponentType`, but the legacy
 * `onboardingCard.appRoute` rendered `<Onboarding initialStep={3} />`. This thin
 * wrapper preserves that exact behavior so the card step is reached on direct
 * load of /onboarding/card.
 */
const OnboardingCard: React.FC = () => (
  <Onboarding initialStep={3} stepDisplayMode="remainingFlow" />
)

export default OnboardingCard
